import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, unref as _unref, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { class: "control" }
const _hoisted_4 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_5 = {
  key: 1,
  class: "help is-danger"
}
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "control" }
const _hoisted_8 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_9 = {
  key: 1,
  class: "help is-danger"
}
const _hoisted_10 = { class: "field" }
const _hoisted_11 = { class: "control select" }
const _hoisted_12 = ["value"]

import { CreateContactAttributeViewModel } from '@/messaging/models/createContactAttributeViewModel';
import Toast from '@/shared/services/toast';
import { ContactAttributeType } from '@/messaging/models/contactAttributeType';
import ReadonlyField from '@/shared/components/ReadonlyField.vue';
import Modal from '@/shared/components/Modal.vue';
import { CREATE_CONTACT_ATTRIBUTE } from '@/store/attributes/actionTypes';
import { ContactAttributeViewModel } from '@/messaging/models/contactAttributeViewModel';
import { useStore } from 'vuex';
import { onMounted, PropType, ref, watch } from 'vue';
import useVuelidate from '@vuelidate/core';
import { maxLength, required } from '@vuelidate/validators';


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateAttribute',
  props: {
  excludedDataTypes: {
    type: Array as PropType<ContactAttributeType[]>,
    default: [],
  },
},
  emits: ["cancel", "create"],
  setup(__props, { emit: __emit }) {

const props = __props;

const store = useStore();
const createAttribute = (request: CreateContactAttributeViewModel): Promise<ContactAttributeViewModel> =>
  store.dispatch(CREATE_CONTACT_ATTRIBUTE, request);

const attribute = ref<CreateContactAttributeViewModel>({
  id: '',
  name: '',
  description: '',
  type: 'text',
});
const dataTypeOptions = ref([
  { value: ContactAttributeType.Text, display: 'Text' },
  { value: ContactAttributeType.Number, display: 'Number' },
  { value: ContactAttributeType.Decimal, display: 'Decimal' },
  { value: ContactAttributeType.Date, display: 'Date' },
]);
const updateInProgress = ref(false);
const nameInput = ref<HTMLInputElement | null>(null);

const emit = __emit;

const validName = (value: string) => value.search(/[^a-zA-Z0-9 _\-]/) === -1;
const validations = {
  attribute: {
    description: {
      required,
      maxLength: maxLength(255),
    },
    name: {
      required,
      validName,
      maxLength: maxLength(50),
    },
  },
};

const $v = useVuelidate(validations, { attribute });

watch(
  () => attribute.value.name,
  (to) => (attribute.value.id = toCamelCase(to)),
  { immediate: true },
);

onMounted(() => {
  if (nameInput.value) {
    nameInput.value.focus();
  }

  if (props.excludedDataTypes) {
    dataTypeOptions.value = dataTypeOptions.value.filter(
      (t) => !props.excludedDataTypes.find((excluded) => excluded === t.value),
    );
  }
});

function closeModal() {
  emit('cancel');
}

function isFieldNotPopulated(vuelidateObject: any, fieldName: string): boolean {
  const field = vuelidateObject[fieldName];
  return !field || (field.$invalid && !field.required && field.$dirty);
}

function isFieldInvalid(vuelidateObject: any, fieldName: string): boolean {
  const field = vuelidateObject[fieldName];
  return !field || (field.$invalid && field.$dirty);
}

async function update() {
  if (updateInProgress.value) {
    return;
  }

  updateInProgress.value = true;
  try {
    const createdAttribute = await createAttribute(attribute.value);
    Toast.showSuccess('Attribute successfully created');
    emit('create', createdAttribute);
  } catch (err) {
    Toast.showError(err.message);
  } finally {
    updateInProgress.value = false;
  }
}

function toCamelCase(input: string): string {
  const words = toWords(input);
  let result = '';
  for (let i = 0; i < words.length; i++) {
    let word = words[i].toLowerCase();
    if (i !== 0) {
      word = word.substr(0, 1).toUpperCase() + word.substr(1);
    }

    result += word;
  }
  return result;
}

function toWords(input: string): RegExpMatchArray {
  if (!input) {
    return [] as unknown as RegExpMatchArray;
  }

  const regex =
    /[A-Z\xC0-\xD6\xD8-\xDE]?[a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g;
  return input.match(regex) as RegExpMatchArray;
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!

  return (_openBlock(), _createBlock(Modal, { onCancel: closeModal }, {
    title: _withCtx(() => _cache[5] || (_cache[5] = [
      _createElementVNode("p", { class: "modal-card-title" }, "Create Contact Attribute", -1)
    ])),
    body: _withCtx(() => [
      _createElementVNode("fieldset", null, [
        _createElementVNode("div", _hoisted_1, [
          _cache[6] || (_cache[6] = _createElementVNode("label", { class: "label" }, "ID", -1)),
          _createVNode(ReadonlyField, {
            readonlyValue: attribute.value.id
          }, null, 8, ["readonlyValue"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _cache[7] || (_cache[7] = _createElementVNode("label", {
            class: "label",
            for: "name"
          }, "Name", -1)),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              ref_key: "nameInput",
              ref: nameInput,
              type: "text",
              class: "input",
              id: "name",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((attribute.value.name) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref($v).attribute.name.$touch()))
            }, null, 544), [
              [_vModelText, attribute.value.name]
            ]),
            (isFieldNotPopulated(_unref($v).attribute, 'name'))
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Name is required"))
              : (isFieldInvalid(_unref($v).attribute, 'name'))
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Name may only contain letters, numbers, spaces, underscores or hyphens, and must be no longer than 50 characters "))
                : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[8] || (_cache[8] = _createElementVNode("label", {
            class: "label",
            for: "description"
          }, "Description", -1)),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("textarea", {
              class: "textarea",
              id: "description",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((attribute.value.description) = $event)),
              onInput: _cache[3] || (_cache[3] = ($event: any) => (_unref($v).attribute.description.$touch()))
            }, null, 544), [
              [_vModelText, attribute.value.description]
            ]),
            (isFieldNotPopulated(_unref($v).attribute, 'description'))
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Description is required "))
              : (isFieldInvalid(_unref($v).attribute, 'description'))
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Description must be no longer than 255 characters "))
                : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[9] || (_cache[9] = _createElementVNode("label", {
            class: "label",
            for: "dataType"
          }, "Data type", -1)),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("select", {
              id: "dataType",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((attribute.value.type) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataTypeOptions.value, (type) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: type.value,
                  value: type.value
                }, _toDisplayString(type.display), 9, _hoisted_12))
              }), 128))
            ], 512), [
              [_vModelSelect, attribute.value.type]
            ])
          ])
        ])
      ])
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_n_button_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            id: "create-attribute-submit-btn",
            variant: "primary",
            disabled: _unref($v).$invalid,
            loading: updateInProgress.value,
            onClick: update
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode(" Create Attribute ")
            ])),
            _: 1
          }, 8, ["disabled", "loading"]),
          _createVNode(_component_n_button, { onClick: closeModal }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode("Cancel")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})